export default {
  en: {
    'components.terms-and-conditions.title': 'Terms & Conditions',
  },
};
